export enum SentryLogger {
  ERROR = 'JS_ERROR',
  INFO = 'JS_INFO',
  DEBUG = 'JS_DEBUG',
}

export enum SentryLoggerLevel {
  ERROR = 'error',
  INFO = 'info',
  DEBUG = 'debug',
}

export enum Platform {
  PRODUCTION = 'production',
  ACCEPTANCE = 'acceptance',
  TEST = 'test',
  TEST2 = 'test2',
  TESTAUT = 'testaut',
  DEVELOPMENT = 'development',
}

export enum PlatformUrl {
  PRODUCTION = 'www.ns.nl',
  ACCEPTANCE = 'acc.ns.nl',
  TEST = 'www.test.ns.nl',
  TEST2 = 'www2.test.ns.nl',
  TESTAUT = 'www.testaut.ns.nl',
  DEVELOPMENT = 'localhost',
}

export enum Language {
  DUTCH = 'nl',
  ENGLISH = 'en',
}

export enum MediaQuery {
  MIN_WIDTH_480 = '(min-width: 480px)',
  MIN_WIDTH_640 = '(min-width: 640px)',
  MIN_WIDTH_768 = '(min-width: 768px)',
  MIN_WIDTH_912 = '(min-width: 912px)',
  MIN_WIDTH_1024 = '(min-width: 1024px)',
  MIN_WIDTH_1200 = '(min-width: 1200px)',
  MIN_WIDTH_1265 = '(min-width: 1265px)',
  MAX_WIDTH_480 = '(max-width: 480px)',
  MAX_WIDTH_640 = '(max-width: 640px)',
  MAX_WIDTH_768 = '(max-width: 768px)',
  MAX_WIDTH_912 = '(max-width: 912px)',
  MAX_WIDTH_1024 = '(max-width: 1024px)',
  MAX_WIDTH_1200 = '(max-width: 1200px)',
  MAX_WIDTH_1265 = '(max-width: 1265px)',
  MIN_HEIGHT_480 = '(min-height: 480px)',
  MIN_HEIGHT_640 = '(min-height: 640px)',
  MIN_HEIGHT_768 = '(min-height: 768px)',
  MIN_HEIGHT_912 = '(min-height: 912px)',
  MIN_HEIGHT_1024 = '(min-height: 1024px)',
  MIN_HEIGHT_1366 = '(min-height: 1366px)',
  MAX_HEIGHT_480 = '(max-height: 480px)',
  MAX_HEIGHT_640 = '(max-height: 640px)',
  MAX_HEIGHT_768 = '(max-height: 768px)',
  MAX_HEIGHT_912 = '(max-height: 912px)',
  MAX_HEIGHT_1024 = '(max-height: 1024px)',
  MAX_HEIGHT_1366 = '(max-height: 1366px)',
}
